"use strict";

exports.__esModule = true;
exports.Pagination = void 0;

var React = _interopRequireWildcard(require("react"));

var _icons = require("@manifest-ui/icons");

var _Pagination = require("./Pagination.styles");

var _hooks = require("@manifest-ui/hooks");

var _jsxFileName = "/home/runner/work/manifest-ui/manifest-ui/packages/pagination/src/Pagination.tsx";

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Pagination = React.forwardRef((props, ref) => {
  const {
    boundaries,
    defaultPage,
    onChange,
    page: pageProp,
    rowsPerPage,
    siblings,
    showPageNumbers = true,
    totalRowCount,
    ...other
  } = props;
  const {
    next,
    page,
    pages,
    pageCount,
    previous,
    setPage
  } = (0, _hooks.usePagination)({
    boundaries,
    defaultPage,
    onChange,
    page: pageProp,
    rowsPerPage,
    siblings,
    totalRowCount
  });
  return React.createElement(_Pagination.StyledPagination, _extends({
    className: "manifestui-pagination",
    ref: ref
  }, other, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 7
    }
  }), React.createElement(_Pagination.StyledPaginationButton, {
    "aria-label": "go to previous page",
    className: "manifestui-pagination-button",
    disabled: page === 1,
    onClick: previous,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 9
    }
  }, React.createElement(_icons.KeyboardArrowLeft, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 11
    }
  }), React.createElement(_Pagination.StyledPaginationText, {
    className: "manifestui-pagination-text",
    "data-placement": "end",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 11
    }
  }, "Previous")), showPageNumbers && pages.map((item, index) => React.createElement(React.Fragment, {
    key: `${item}_${index}`,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 13
    }
  }, item === 'dots' && React.createElement(_Pagination.StyledPaginationEllipsis, {
    className: "manifestui-pagination-ellipsis",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 17
    }
  }, "..."), item !== 'dots' && React.createElement(_Pagination.StyledPaginationButton, {
    "aria-current": item === page ? 'true' : undefined,
    "aria-label": `${item === page ? '' : 'go to '}page ${String(item)}`,
    className: "manifestui-pagination-button",
    "data-active": item === page ? '' : undefined,
    onClick: () => {
      setPage(item);
    },
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 17
    }
  }, item.toString()))), React.createElement(_Pagination.StyledPaginationButton, {
    "aria-label": "go to next page",
    className: "manifestui-pagination-button",
    disabled: page === pageCount,
    onClick: next,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 9
    }
  }, React.createElement(_Pagination.StyledPaginationText, {
    className: "manifestui-pagination-text",
    "data-placement": "start",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 11
    }
  }, "Next"), React.createElement(_icons.KeyboardArrowRight, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 11
    }
  })));
});
exports.Pagination = Pagination;
Pagination.displayName = 'Pagination';